import React, { useEffect, useState } from 'react';
import { Image, Spin, message } from 'antd';
import { ImagePicker, Toast } from 'antd-mobile';
import axios from "../../utils/selfRequest";
import './index.less';
import UploadFelsProgress from "./indexUpload";
import { Modal, Upload } from 'antd';
import { noTags } from "../../utils/common";

import { language } from "@/utils/language";
import PubSub from "pubsub-js";


// 测试页
export default function UploadFile(props) {

  console.log(props, '上传题');
  const { uploadPrefer } = props?.info?.preferences;
  const maxSize = uploadPrefer?.maxSize || 1; // 限制上传的最大文件数 
  const acceptArr = uploadPrefer?.uploadFileType || []; // 限制文件类型
  const fileSize = uploadPrefer?.fileSize || 1; // 限制文件大小 
  const uploadType = uploadPrefer?.uploadType; // 1：不限制文件类型，2：限制文件类型，3：仅限拍照后上传，4：仅限录视频后上传 
  const [picList, setPicList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const answer = props?.info?.fileList || [];
    if (answer.length > 0) {
      setPicList(answer);
    }
  }, [])

  // 上传
  const onChange = (files) => {
    const dataTypeFlag = filterUploadFileType(files);
    const dataSizeFlag = filterUploadFileSize(files);
    if ((files.length + picList.length) > maxSize) {
      PubSub.publish("Modalalert",`【${noTags(props.info.description)}】最多只允许上传${maxSize}个文件`);
      return false;
    }
    if (dataTypeFlag && dataSizeFlag) {
      const formData = new FormData();
      files.forEach((item) => {
        formData.append('files', item.file);
      })
      setLoading(true);
      axios.post(`answer/test/uploadAnswerFile?questionId=${props?.info?.id}&sampleId=${props?.info?.sampleId}`, formData).then((res) => {
        setLoading(false);
        const { msg, data } = res;
        if (data.length > 0) {
          const resPicArr = [...picList, ...data];
          setPicList([...resPicArr]);
          let newObj = {};
          resPicArr.forEach(item => {
            newObj = { ...newObj, ...item.answer }
          })
          props.changeAnswer(newObj)
        } else {
          message.error(msg);
        }
      }).catch((err) => {
        setLoading(false);
        message.error(err.msg || '系统异常');
      })
    }
  }
  // 上传前的格式校验
  const filterUploadFileType = (files) => {
    if (uploadType !== 2) return true;
    if (acceptArr.length === 0) return true;
    for (let i = 0; i < files.length; i++) {
      const currentFile = files[i].file;
      const filteTypeArr = currentFile.name.split(".");
      const filteType = filteTypeArr[filteTypeArr.length - 1].toLowerCase();
      if (!(acceptArr.includes(filteType))) {
        if (sessionStorage.getItem("internationalizeFlag") == "jap") {
          PubSub.publish("Modalalert",`【${noTags(props.info.description)}】${language().upload_file_type} 形式のファイルをアップロードしてください。`);
          return false;
        }
        
        PubSub.publish("Modalalert",`【${noTags(props.info.description)}】${language().input_placeholder}${acceptArr.toString()} ${language().upload_file_type}`);
        return false;
      }
      return true;
    }
  }
  // 上传前的大小校验
  const filterUploadFileSize = (files) => {
    for (let i = 0; i < files.length; i++) {
      const currentFile = files[i].file;
      if ((currentFile.size / 1024 / 1024) > fileSize) {
        if (sessionStorage.getItem("internationalizeFlag") == "jap") {
          PubSub.publish("Modalalert",`【${noTags(props.info.description)}】${language().upload_file_size}メガバイト以内のファイルをアップロードしてください`);
          return false;
        }
        
        PubSub.publish("Modalalert",`【${noTags(props.info.description)}】${language().upload_file} ${fileSize} ${language().upload_file_size}`);
        return false;
      }
      return true;
    }
  }
  const getAccept = () => {
    if (uploadType === 3) {
      // 仅限拍照后上传
      return 'image/*';
    } else if (uploadType === 4) {
      // 仅限录视频后上传 
      return 'video/*';
    } else {
      return null;
    }
  }
  const getCapture = () => {
    if (uploadType === 3) {
      // 仅限拍照后上传
      return 'camera';
    } else if (uploadType === 4) {
      return 'camcorder';
    } else {
      return null;
    }
  }
  const getBg = (item) => {
    const typeArr = item?.name.split('.')
    const type = typeArr[typeArr.length - 1].toLowerCase();
    if (['doc', 'docx', 'pdf', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'].includes(type)) {
      // 返回文本背景类 通过css添加
      return 'textBg';
    } else if (['rar', 'zip', 'gzip'].includes(type)) {
      return 'fileBg';
    } else if (['mp4', 'm3ua', 'flv', 'f4v', 'webm', 'mov', 'm4v', '3gp', 'avi', 'wmv'].includes(type)) {
      return 'videoBg';
    } else if (['mp3', 'wma', 'wav', 'amr', 'm4a', 'aac'].includes(type)) {
      return 'audioBg';
    }
  }
  // 删除
  const remove = (id, index) => {
    return () => {
      axios.get(`answer/test/deleteAnswerFile?fileId=${id}`).then((res) => {
        picList.splice(index, 1);
        setPicList([...picList]);
        let newObj = {};
        picList.forEach(item => {
          newObj = { ...newObj, ...item.answer }
        })
        props.changeAnswer(newObj);
      }).catch((err) => {
        message.error(err.msg);
      })
    }
  }


  const uploadSuccessRes = (res) => {
    const resPicArr = [...picList, ...res];
    setPicList([...resPicArr]);
    let newObj = {};
    resPicArr.forEach(item => {
      newObj = { ...newObj, ...item.answer }
    })
    props.changeAnswer(newObj)
  }

  return (
    <Spin spinning={loading}>
      <div className='uploadWraper'>
        <div className='listBox'>
          {
            picList.map((item, index) => {
              const typeArr = item?.name.split('.')
              const type = typeArr[typeArr.length - 1].toLowerCase();
              return (
                <React.Fragment key={item.id}>
                  {
                    ['gif', 'png', 'jpg', 'jpeg', 'bmp'].includes(type) ? (
                      <div className='list'>
                        <Image className='imgBox' preview={true} src={item.url} alt="" />
                        <span className='removeBox' onClick={remove(item.id, index)}></span>
                      </div>
                    ) : (
                      <div className='otherList'>
                        <div className='content'>
                          <span className={getBg(item)}></span>
                          <div className='name'>{item.name}</div>
                        </div>
                        <span className='removeBox' onClick={remove(item.id, index)}></span>
                      </div>
                    )
                  }
                </React.Fragment>
              )
            })
          }
          {
            picList.length < maxSize && (
              <div className='uploadBox'>
                {/* {uploadType} */}
                {
                  (uploadType == 3 || uploadType == 4) ? (
                    <ImagePicker
                      type='file'
                      accept={getAccept()}
                      capture={getCapture()}
                      length={1}
                      multiple={true}
                      onChange={onChange}
                      onAddImageClick={() => { }}
                      disableDelete
                    />
                  ) : (
                    <UploadFelsProgress
                      felsType={acceptArr}
                      uploadType={uploadType}
                      maxCount={maxSize}
                      uploadSuccessRes={uploadSuccessRes}
                      size={fileSize}
                      picListLength={picList.length}
                      setLoading={setLoading}
                      {...props}
                    >
                      <div class="ant-spin-nested-loading">
                        <div class="ant-spin-container">
                          <div class="">
                            <div class="listBox">
                              <div class="uploadBox"> <div class="am-image-picker">
                                <div class="am-image-picker-list" role="group">
                                  <div class="am-flexbox am-flexbox-align-center">
                                    <div class="am-flexbox-item">
                                      <div class="am-image-picker-item am-image-picker-upload-btn" role="button"
                                        aria-label="Choose and add image">
                                        {/* <input type="file" multiple="" /> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </UploadFelsProgress>

                  )
                }


              </div>
            )
          }
          {/* <IndexUpload {...props}></IndexUpload> */}
        </div>
      </div>
    </Spin>
  );
}
